import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "itemlist-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "empty-message"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["aria-label", "aria-details", "onClick", "onKeydown"]
const _hoisted_6 = {
  key: 0,
  "aria-hidden": "true",
  class: "itemlist-type-icon itemlist-type-icon-folder"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  "aria-hidden": "true",
  class: "itemlist-type-icon itemlist-type-icon-session"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  "aria-hidden": "true",
  class: "itemlist-type-title-title"
}
const _hoisted_11 = { class: "itemlist-type-title-title-title" }
const _hoisted_12 = {
  key: 0,
  class: "itemlist-type-title-title-duration"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 1,
  class: "itemlist-type-title-title-duration"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 0,
  class: "itemlist-column-text"
}
const _hoisted_17 = {
  key: 1,
  class: "itemlist-column-item itemlist-column-text supplementary-files"
}
const _hoisted_18 = { class: "itemlist-fileupload" }
const _hoisted_19 = { class: "fileupload-count" }
const _hoisted_20 = ["aria-label"]
const _hoisted_21 = {
  key: 0,
  class: "itemlist-column-text"
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = ["src"]
const _hoisted_24 = {
  class: "itemlist-column-text created-at",
  style: {"width":"100%"}
}
const _hoisted_25 = { class: "itemlist-viewmore-button-wrapper" }

import { ref, useTemplateRef, computed, watch, nextTick } from "vue";
import { formatDateToCurrentLocale } from "@/assets/helpers";
import Skeleton from "primevue/skeleton";
import UploadButton from "../UploadButton.vue";
import IconButton from "../IconButton.vue";
import { SessionWithOrdersAndType } from "../../types/session-interfaces";
import { FolderWithSessions } from "../../types/folder-interfaces";
import {
  ItemListMenuProp,
  ItemListColumn,
} from "../../types/itemlist-interfaces";
import { convertSecondsToMS } from "../../assets/helpers_legacy.js";
import { useStore } from "vuex";
import { useToast } from "primevue/usetoast";

interface MenuItemBase {
  label?: string;
  ariaLabel?: string;
  ariaDescribedBy?: string;
  command?: () => void;
  // eslint-disable-next-line no-unused-vars
  keyHandler?: (event: KeyboardEvent) => void;
  icon?: string;
  disabled?: boolean;
  visible?: boolean;
  class?: any;
}

type MenuItem = MenuItemBase;

const itemsPerPage = 10;


export default /*@__PURE__*/_defineComponent({
  __name: 'ItemList',
  props: {
    loader: { type: Boolean },
    columns: {},
    data: {},
    sessionMenuProps: {},
    folderMenuProps: {},
    lazyLoading: { type: Boolean },
    canLoadMore: { type: Boolean },
    onLazyLoad: { type: Function },
    openFolder: { type: Function },
    openSession: { type: Function },
    isArchive: { type: Boolean },
    scrollHeight: {},
    onSortChange: { type: Function },
    onSortOrderChange: { type: Function },
    storageKey: {}
  },
  setup(__props: any, { expose: __expose }) {

const ThreeDotsWhiteIcon =
  require("../../assets/images/ThreeDotsWhiteIcon.svg") as string;
const FolderIconImage =
  require("../../assets/images/FolderDarkIcon.svg") as string;
const AudioIconImage = require("../../assets/images/AudioIcon.svg") as string;
const ClockIcon = require("../../assets/images/ClockSmall.svg") as string;
const SmallSessionIcon =
  require("../../assets/images/SmallSessionIcon.svg") as string;
const SortIcon = require("../../assets/images/SortIcon.svg") as string;
const SortIconDescending =
  require("../../assets/images/SortIconDescending.svg") as string;
const SortIconAscending =
  require("../../assets/images/SortIconAscending.svg") as string;
const RestoreIcon = require("../../assets/images/Restore-black.svg") as string;

const store = useStore(),
  toast = useToast();

const props = __props;

const selectedItems = computed({
  get: () => store.getters["itemList/getSelectedItems"],
  set: (val) => store.dispatch("itemList/updateSelection", val),
});

const onRowClick = async (event: {
  data: SessionWithOrdersAndType | FolderWithSessions;
}) => {
  if (event.data.type === "folder") {
    if (props.openFolder) {
      props.openFolder(event.data);
    }
  } else {
    props.openSession(event.data);
  }
};

function countUpload(uploadsArray: []) {
  const filteredUploads = uploadsArray.filter(
    (upload: any) => upload.type === "mp-supplementary"
  );
  return filteredUploads.length;
}

function formatTitle(title: string) {
  if (title.length > 48) {
    return title.slice(0, 48) + "...";
  }
  return title;
}

const PopupMenus = ref<MenuItem[]>([]);
const menuRef = useTemplateRef("menu");

const visibleCount = ref(0);

watch(
  () => props.data,
  function () {
    visibleCount.value = props.data.length ?? itemsPerPage;
  },
  { once: false, immediate: true }
);
const menuKeydownBound = ref(false);

const visibleData = computed(() => {
  if (props.loader) {
    // when the prop is loading, fill the data with dummy rows for the Skeleton
    // component to render
    return Array(5).fill({});
  } else if (props.data) {
    if (props.isArchive) {
      // show all archived items
      return props.data;
    } else {
      return props.data.slice(0, visibleCount.value);
    }
  } else {
    return [];
  }
});

// fill in with a Loading column to load in Skeleton component when the column
// is loading in
const tableColumns = computed(() => {
  return props.columns?.length
    ? props.columns
    : [{ header: "Loading...", field: "loading", width: "100%" }];
});

const canLoadMore = computed(() => {
  if (props.lazyLoading) {
    return props.canLoadMore || visibleData.value.length < props.data.length;
  } else {
    return visibleData.value.length < props.data.length;
  }
});

async function loadMore() {
  if (props.lazyLoading) {
    if (props.onLazyLoad) {
      await props.onLazyLoad();
    }
  }

  if (visibleCount.value + itemsPerPage <= props.data.length) {
    visibleCount.value += itemsPerPage;
  } else {
    visibleCount.value = props.data.length;
  }
}

function formatDuration(durationValue: number | null | undefined): string {
  if (durationValue && durationValue !== 0) {
    return convertSecondsToMS(durationValue / 1000);
  }
  return "-";
}

function getMenuRoot(): HTMLElement | null {
  // Try PrimeVue instance overlay first
  const inst = Array.isArray(menuRef.value)
    ? (menuRef.value[0] as any)
    : (menuRef.value as any);

  const cand = inst?.overlay ?? inst?.$el ?? null;
  if (cand && typeof (cand as any).querySelectorAll === "function") {
    return cand as HTMLElement;
  }

  // Prefer your class-qualified overlay
  const overlays = document.querySelectorAll(
    ".table-menu-popup.p-menu-overlay"
  );
  if (overlays.length) return overlays[overlays.length - 1] as HTMLElement;

  // Fallback to generic PrimeVue overlay
  const generic = document.querySelectorAll(".p-menu-overlay");
  return generic.length ? (generic[generic.length - 1] as HTMLElement) : null;
}

function getMenuItems(): HTMLElement[] {
  const root = getMenuRoot();
  if (!root) return [];
  return Array.from(
    root.querySelectorAll(
      ".p-menu-item:not(.p-disabled) .p-menu-item-link, " +
        ".p-menu-item:not(.p-disabled) a, " +
        ".p-menu-item:not(.p-disabled) button"
    )
  ) as HTMLElement[];
}

function bindMenuKeyboardOnce() {
  const root = getMenuRoot();
  if (!root || menuKeydownBound.value) return;
  root.addEventListener("keydown", onMenuKeydown);
  menuKeydownBound.value = true;
}

function focusFirstMenuItem() {
  const items = getMenuItems();
  items[0]?.focus();
}

function onMenuKeydown(e: KeyboardEvent) {
  const items = getMenuItems();
  if (!items.length) return;

  const active = document.activeElement as HTMLElement;

  let i = Math.max(0, items.indexOf(active));

  const move = (next: number) =>
    items[(next + items.length) % items.length].focus();

  switch (e.key) {
    case "ArrowDown":
      e.preventDefault();
      move(i + 1);
      break;
    case "ArrowUp":
      e.preventDefault();
      move(i - 1);
      break;
    case "Tab":
      e.preventDefault();
      if (e.shiftKey) move(i - 1);
      else move(i + 1);
      break;
    case "Home":
      e.preventDefault();
      move(0);
      break;
    case "End":
      e.preventDefault();
      move(items.length - 1);
      break;
    case "Enter":
    case " ":
      e.preventDefault();
      active?.click();
      break;
    case "Escape": {
      const inst = Array.isArray(menuRef.value)
        ? (menuRef.value[0] as any)
        : (menuRef.value as any);
      inst?.hide?.();
      break;
    }
  }
}

async function toggleSessionMenu(
  event: Event,
  rowData: FolderWithSessions | SessionWithOrdersAndType
) {
  const selectedMenuProps =
    rowData.type === "session" ? props.sessionMenuProps : props.folderMenuProps;

  if (!selectedMenuProps?.length) return;

  PopupMenus.value = selectedMenuProps.map((item) => {
    const base: MenuItem = {};

    if (item.label) base.label = item.label;
    if (item.icon) base.icon = item.icon + " itemlist-popupmenu";
    if (item.class) base.class = item.class;
    if (item.ariaLabel) base.ariaLabel = item.ariaLabel;
    if (item.command) base.command = () => item.command(rowData);

    if (item.checkLabel) base.label = item.checkLabel(rowData);
    if (item.checkVisible) base.visible = item.checkVisible(rowData);
    if (item.checkDisable) base.disabled = item.checkDisable(rowData);

    return base;
  });

  const inst = Array.isArray(menuRef.value)
    ? (menuRef.value[0] as any)
    : (menuRef.value as any);
  inst?.toggle?.(event);

  // Wait for overlay teleport + mount
  await nextTick();
  requestAnimationFrame(() => {
    bindMenuKeyboardOnce();
    focusFirstMenuItem();
  });
}

function isSelected(row: SessionWithOrdersAndType | FolderWithSessions) {
  return selectedItems.value.some((r: { id: string }) => r.id === row.id);
}

function isSelectable(
  row: SessionWithOrdersAndType | FolderWithSessions
): boolean {
  const type = selectedItems.value[0]?.type;
  return !type || row.type === type || isSelected(row);
}

function getSortIcon(order: number) {
  if (order === 1) {
    return SortIconAscending;
  }
  if (order === -1) {
    return SortIconDescending;
  }

  return SortIcon;
}
function formatSessionsCount(numSessions: number | null | undefined) {
  if (!numSessions) {
    return `0 session`;
  } else if (numSessions <= 1) {
    return `${numSessions} session`;
  } else {
    return `${numSessions} sessions`;
  }
}

function getRowClass(row: SessionWithOrdersAndType | FolderWithSessions) {
  return {
    "row-unselectable": !isSelectable(row),
  };
}

async function restoreItem(
  data: SessionWithOrdersAndType | FolderWithSessions
) {
  await store.dispatch("itemList/unarchiveItem", data.id);
  toast.add({
    severity: "secondary",
    summary: `Item restored successfully.`,
    life: 3000,
    group: "notification",
  });
}

__expose({
  toggleSessionMenu,
  visibleCount,
});

return (_ctx: any,_cache: any) => {
  const _component_Column = _resolveComponent("Column")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Toast = _resolveComponent("Toast")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createBlock(_component_DataTable, {
        key: `${visibleData.value.length}-${_ctx.storageKey || 'itemlist'}`,
        selection: selectedItems.value,
        "onUpdate:selection": _cache[0] || (_cache[0] = ($event: any) => ((selectedItems).value = $event)),
        breakpoint: "0px",
        value: visibleData.value,
        class: "itemlist",
        onRowClick: onRowClick,
        rowStyle: () => ({ backgroundColor: '#53435f' }),
        dataKey: 'id',
        scrollable: "",
        scrollHeight: _ctx.scrollHeight || '100vh',
        highlightOnSelect: true,
        stateStorage: "local",
        stateKey: _ctx.storageKey,
        "onUpdate:sortField": _ctx.onSortChange,
        "onUpdate:sortOrder": _ctx.onSortOrderChange,
        rowClass: getRowClass,
        "virtual-scroller-options": { itemSize: 88 }
      }, {
        empty: _withCtx(() => [
          (!props.loader)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[2] || (_cache[2] = [
                _createElementVNode("p", null, "No search results found", -1),
                _createElementVNode("p", null, "We can't find any item matching your search.", -1)
              ])))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_unref(Skeleton), {
                  width: "100%",
                  height: "40rem"
                })
              ])),
          _cache[3] || (_cache[3] = _createElementVNode("span", null, null, -1))
        ]),
        default: _withCtx(() => [
          (!_ctx.isArchive)
            ? (_openBlock(), _createBlock(_component_Column, {
                key: 0,
                selectionMode: "multiple",
                "aria-label": "Select row"
              }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableColumns.value, (col) => {
            return (_openBlock(), _createBlock(_component_Column, {
              icon: col.icon,
              sortable: col.sortable,
              class: _normalizeClass(col.class),
              key: col.id,
              field: col.field,
              dataType: col.dataType,
              header: col.icon ? '' : col.header,
              style: _normalizeStyle(`width: ${col.width}`)
            }, _createSlots({
              sorticon: _withCtx(({ sortOrder }) => [
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    src: getSortIcon(sortOrder),
                    alt: "SortIcon",
                    class: "itemlist-sorticon"
                  }, null, 8, _hoisted_4)
                ])
              ]),
              _: 2
            }, [
              (props.loader)
                ? {
                    name: "body",
                    fn: _withCtx((col) => [
                      _createVNode(_unref(Skeleton), {
                        width: col.data.width,
                        height: "2.5rem"
                      }, null, 8, ["width"])
                    ]),
                    key: "0"
                  }
                : (col.header === 'TITLE')
                  ? {
                      name: "body",
                      fn: _withCtx((col) => [
                        _createElementVNode("div", {
                          "aria-label": col.data.type === 'folder' ? 
            `${col.data.type} titled ${col.data.title} containing ${formatSessionsCount(col.data.sessions.length)} sessions` :
            `${col.data.type} titled ${col.data.title}, duration ${formatDuration(col.data.uploads?.find((upload) => upload.type !== 'mp-supplementary')?.duration)}.`
            ,
                          "aria-details": `Activate to open the ${col.data.type}`,
                          class: "itemlist-column-item itemlist-type-title",
                          onClick: ($event: any) => (onRowClick({ data: col.data })),
                          onKeydown: 
              ($event) => {
                if ($event.key === 'Enter') {
                  $event.preventDefault();
                  onRowClick({ data: col.data });
                }
              }
            ,
                          tabindex: "0",
                          "aria-role": "button"
                        }, [
                          (col.data.type === 'folder')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createElementVNode("img", {
                                  src: _unref(FolderIconImage),
                                  alt: "Folder"
                                }, null, 8, _hoisted_7)
                              ]))
                            : _createCommentVNode("", true),
                          (col.data.type === 'session')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("img", {
                                  src: _unref(AudioIconImage),
                                  alt: "Media Session"
                                }, null, 8, _hoisted_9)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, _toDisplayString(formatTitle(col.data.title)), 1),
                            (col.data.type === 'session')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createElementVNode("img", {
                                    src: _unref(ClockIcon),
                                    alt: "ClockIcon"
                                  }, null, 8, _hoisted_13),
                                  _createTextVNode(" " + _toDisplayString(formatDuration(col.data.uploads?.find((upload) => upload.type !== 'mp-supplementary')?.duration)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (col.data.type === 'folder')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _createElementVNode("img", {
                                    src: _unref(SmallSessionIcon),
                                    alt: "SessionSmallIcon"
                                  }, null, 8, _hoisted_15),
                                  _createTextVNode(" " + _toDisplayString(formatSessionsCount(col.data.sessions.length)), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 40, _hoisted_5)
                      ]),
                      key: "1"
                    }
                  : (col.header === 'SUPPLEMENTARY FILES')
                    ? {
                        name: "body",
                        fn: _withCtx((col) => [
                          (col.data.type !== 'session')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString("-")))
                            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createVNode(UploadButton, {
                                  type: 'supplementaryFiles',
                                  additionalUploads: col.data.uploads,
                                  sessionId: col.data.id,
                                  "aria-label": "Upload supplementary files"
                                }, null, 8, ["additionalUploads", "sessionId"]),
                                _createElementVNode("div", _hoisted_18, [
                                  _createElementVNode("span", _hoisted_19, _toDisplayString(countUpload(col.data.uploads)), 1),
                                  _cache[4] || (_cache[4] = _createTextVNode("/5 files "))
                                ])
                              ]))
                        ]),
                        key: "2"
                      }
                    : (col.header === 'NOTES STATUS')
                      ? {
                          name: "body",
                          fn: _withCtx((col) => [
                            _createElementVNode("div", {
                              class: _normalizeClass(["tag", col.data.noteStatus]),
                              style: {"max-width":"min-content"},
                              "aria-label": `Notes status: ${
              col.data.noteStatus ? col.data.noteStatus : ''
            }`
                            }, [
                              (
                col.data.noteStatus === '' ||
                col.data.noteStatus === 'no-value' ||
                !col.data.noteStatus
              )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString("-")))
                                : (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(col.data.noteStatus), 1))
                            ], 10, _hoisted_20)
                          ]),
                          key: "3"
                        }
                      : (col.header === '' && !_ctx.isArchive)
                        ? {
                            name: "body",
                            fn: _withCtx((col) => [
                              _withDirectives(_createVNode(IconButton, {
                                icon: _unref(ThreeDotsWhiteIcon),
                                alt: 'Settings',
                                xsmall: "",
                                onClick: (e) => toggleSessionMenu(e, col.data),
                                enterPress: (e) => toggleSessionMenu(e, col.data),
                                "aria-haspopup": "true",
                                ariaLabel: "Settings"
                              }, null, 8, ["icon", "onClick", "enterPress"]), [
                                [
                                  _directive_tooltip,
                                  'Settings',
                                  void 0,
                                  { top: true }
                                ]
                              ]),
                              _createVNode(_component_Menu, {
                                ref_for: true,
                                ref: "menu",
                                id: "actions_menu",
                                class: "table-menu-popup",
                                model: PopupMenus.value,
                                popup: true,
                                tabindex: 0,
                                ariaLabel: 
              col.data.type === 'session' ? 'Session actions' : 'Folder actions'
            
                              }, null, 8, ["model", "ariaLabel"])
                            ]),
                            key: "4"
                          }
                        : (col.header === '' && _ctx.isArchive)
                          ? {
                              name: "body",
                              fn: _withCtx((col) => [
                                _createVNode(_component_Button, {
                                  onClick: ($event: any) => (restoreItem(col.data)),
                                  class: "itemlist-button",
                                  onKeydown: 
              ($event) => {
                if ($event.key === 'Enter') {
                  $event.preventDefault();
                  restoreItem(col.data);
                }
              }
            ,
                                  "aria-label": 'Restore'
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", {
                                      src: _unref(RestoreIcon),
                                      alt: "RestoreIcon"
                                    }, null, 8, _hoisted_23),
                                    _cache[5] || (_cache[5] = _createTextVNode(" Restore "))
                                  ]),
                                  _: 2,
                                  __: [5]
                                }, 1032, ["onClick", "onKeydown"])
                              ]),
                              key: "5"
                            }
                          : {
                              name: "body",
                              fn: _withCtx((col) => [
                                _createElementVNode("div", _hoisted_24, _toDisplayString(col.field && typeof col.field === "string"
                ? _unref(formatDateToCurrentLocale)(col.data[col.field], true)
                : "-"), 1)
                              ]),
                              key: "6"
                            }
            ]), 1032, ["icon", "sortable", "class", "field", "dataType", "header", "style"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["selection", "value", "scrollHeight", "stateKey", "onUpdate:sortField", "onUpdate:sortOrder"]))
    ]),
    _createElementVNode("div", _hoisted_25, [
      (canLoadMore.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: loadMore,
            onKeydown: _cache[1] || (_cache[1] = 
        ($event) => {
          if ($event.key === 'Enter') {
            $event.preventDefault();
            loadMore();
          }
        }
      ),
            class: "itemlist-viewmore-button",
            "aria-label": "View more"
          }, " View more ", 32))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Toast, {
      position: "top-center",
      group: "notification",
      class: "itemlist-notification-toast-wrapper"
    })
  ], 64))
}
}

})